import { ServiceStoreConfig } from "../types/ServiceStoreTypes";

/**
 * System Module Service Stores
 */
export const systemStores: ServiceStoreConfig[] = [
  {
    name: "api-services",
    options: { enableStorage: false, enableErrorNotifications: true },
  },
  {
    name: "azure-blob-storage",
    options: { enableStorage: true, enableErrorNotifications: true },
  },
  // Add other system services as they are implemented
  // app-version, health, log, removed-items, update-history, weather
];